module.exports = __webpack_public_path__ + "static/media/ruins_logo.e4b6cb0c.png";